import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Firebase configuration — values injected from .env at build time
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Initialize Firebase securely (avoid duplicate app error on hot reload)
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const db = getFirestore(app, "default");
const auth = getAuth(app);

let authReady = false;
const waitForAuth = () => new Promise((resolve) => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
        authReady = true;
        unsubscribe();
        resolve(user);
    });
});
const isAuthReady = () => authReady;
const isUserAuthenticated = () => !!auth.currentUser;
const getCurrentUser = () => auth.currentUser;

export { db, auth, waitForAuth, isAuthReady, isUserAuthenticated, getCurrentUser };
export default app;
